import { render } from "./SelectUbbi.vue?vue&type=template&id=36640a0a&scoped=true"
import script from "./SelectUbbi.vue?vue&type=script&lang=js"
export * from "./SelectUbbi.vue?vue&type=script&lang=js"

import "./SelectUbbi.vue?vue&type=style&index=0&id=36640a0a&scoped=true&lang=css"
import "./SelectUbbi.vue?vue&type=style&index=1&id=36640a0a&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36640a0a"]])

export default __exports__